import { render, staticRenderFns } from "./HeaderAdmin.vue?vue&type=template&id=bce6033e&scoped=true&lang=pug&"
import script from "./HeaderAdmin.vue?vue&type=script&lang=js&"
export * from "./HeaderAdmin.vue?vue&type=script&lang=js&"
import style0 from "./HeaderAdmin.vue?vue&type=style&index=0&id=bce6033e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce6033e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Notification: require('/home/node/components/shared/Notification.vue').default,AvatarUsuario: require('/home/node/components/shared/AvatarUsuario.vue').default})
